module.exports = __webpack_public_path__ + "img/OnPencil.c7b4017c.svg";